import lottie from 'lottie-web';
import data from '../assets/json/lottie/data.json';
import data1 from '../assets/json/lottie/data1.json';
import Chart from 'chart.js';
import Utils from '../js/chartjs/utils.js';
export default {
  mounted() {
    this.loadChart();
    this.loadAnimation('animation', data);
    this.loadAnimation('anim', data1);
  },
  data() {
    return {
      chart: {},
      presets: window.chartColors,
      utils: Utils.Samples.utils,
      inputs: {
        min: 8,
        max: 16,
        count: 8,
        decimals: 2,
        continuity: 1
      }
    };
  },
  methods: {
    loadAnimation(id, data) {
      var animation = lottie.loadAnimation({
        container: document.getElementById(id),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: data
      });
    },
    loadChart() {
      var ctx = document.getElementById('myChart');
      var self = this;
      this.utils.srand(42);
      var data = {
        labels: self.generateLabels(),
        datasets: [
          {
            backgroundColor: this.utils.transparentize(self.presets.red),
            borderColor: self.presets.red,
            data: self.generateData(),
            label: 'D0'
          },
          {
            backgroundColor: this.utils.transparentize(self.presets.orange),
            borderColor: self.presets.orange,
            data: self.generateData(),
            hidden: true,
            label: 'D1',
            fill: '-1'
          },
          {
            backgroundColor: this.utils.transparentize(self.presets.yellow),
            borderColor: self.presets.yellow,
            data: self.generateData(),
            label: 'D2',
            fill: 1
          },
          {
            backgroundColor: this.utils.transparentize(self.presets.green),
            borderColor: self.presets.green,
            data: self.generateData(),
            label: 'D3',
            fill: false
          },
          {
            backgroundColor: this.utils.transparentize(self.presets.blue),
            borderColor: self.presets.blue,
            data: self.generateData(),
            label: 'D4',
            fill: '-1'
          },
          {
            backgroundColor: this.utils.transparentize(self.presets.purple),
            borderColor: self.presets.purple,
            data: self.generateData(),
            label: 'D5',
            fill: '-1'
          }
        ]
      };
      var options = {
        maintainAspectRatio: true,
        spanGaps: false,
        elements: { line: { tension: 0.000001 } },
        plugins: {
          filler: { propagate: false },
          'samples-filler-analyser': { target: 'chart-analyser' }
        }
      };
      this.chart = new Chart(ctx, {
        type: 'radar',
        data: data,
        options: options
      });
    },
    generateData() {
      var self = this;
      var values = this.utils.numbers(self.inputs);
      this.inputs.from = values;
      return values;
    },
    generateLabels() {
      var self = this;
      return this.utils.months({ count: self.inputs.count });
    },
    togglePropagate(btn) {
      var value = btn.target.classList.toggle('btn-on');
      this.chart.options.plugins.filler.propagate = value;
      this.chart.update();
    },
    toggleSmooth(btn) {
      var value = btn.target.classList.toggle('btn-on');
      this.chart.options.elements.line.tension = value ? 0.4 : 0.000001;
      this.chart.update();
    },
    randomize() {
      var self = this;
      this.inputs.from = [];
      this.chart.data.datasets.forEach(function (dataset) {
        dataset.data = self.generateData();
      });
      this.chart.update();
    }
  },
  id: 'cec7ef0d79',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n    <div class="page" data-name="about">\r\n        <div class="navbar">\r\n            <div class="navbar-bg"></div>\r\n            <div class="navbar-inner sliding">\r\n                <div class="left">\r\n                    <a href="#" class="link back">\r\n                        <i class="icon icon-back"></i>\r\n                        <span class="if-not-md">Back</span>\r\n                    </a>\r\n                </div>\r\n                <div class="title">Analysis</div>\r\n            </div>\r\n        </div>\r\n        <div class="page-content">\r\n\r\n            <div class="block-title">\r\n                <h2>ChartJS Radar Chart</h2>\r\n            </div>\r\n            <div class="wrapper"><canvas id="myChart"></canvas></div>\r\n            <div class="block row">\r\n                <button class="col button button-fill button-round button-raised"\r\n                    @click="togglePropagate">Propagate</button>\r\n                <button class="col button button-fill button-round button-raised" @click="toggleSmooth">Smooth</button>\r\n                <button class="col button button-fill button-round button-raised" @click="randomize">Randomize</button>\r\n            </div>\r\n\r\n            <div class="block-title">\r\n                <h2>Lottie Animation</h2>\r\n            </div>\r\n            <div id="animation"></div>\r\n            <div id="anim"></div>\r\n\r\n\r\n        </div>\r\n    </div>\r\n';
      return r;
    }(this);
  },
  style: `
[data-f7-cec7ef0d79] .wrapper {
        min-height: 400px;
        padding: 16px 0;
        position: relative;
    }

[data-f7-cec7ef0d79] .wrapper.col-2 {
        display: inline-block;
        min-height: 256px;
        width: 49%;
    }

    @media (max-width: 400px) {
[data-f7-cec7ef0d79] .wrapper.col-2 {
            width: 100%
        }
    }

[data-f7-cec7ef0d79] .wrapper canvas {
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
    }
`,
  styleScoped: true
};